import React from 'react';

import { Translations } from '@wegoTypes/translations';

import styles from './CarRentalPartners.module.scss';

interface CarRentalPartnersProps {
  translations: Translations;
  pageType: string;
}

const CarRentalPartners: React.FC<CarRentalPartnersProps> = ({ translations, pageType }) => {
  if (pageType !== 'car-rentals') return null;

  return (
    <div className={styles.container}>
      <div className={styles.description}>
        <div className={styles.title}>{translations.car_rental_partners}</div>
        {translations.car_rental_partners_description}
      </div>

      <div>
        <img
          src={
            'https://zen.wego.com/cdn-cgi/image/format=auto/cms/images/car-rental-partners_348526101.png'
          }
          className={styles.image}
          alt={`car-rental-partners`}
        />
      </div>
    </div>
  );
};

export default CarRentalPartners;
